<template>
    <tbody :id="'tbody_item_' + type">
        <tr :id="'rowGroup_item_' + type" class="dtrg-group dtrg-start dtrg-level-0">
            <td colspan="10" class="text-capitalize">
                <div class="row">
                    <div class="col-sm-12 col-md-8">
                        <span class="text-secondary mr-2"><i class="fas" :class="getIcon(type)"></i></span>{{$t('salon_report.item_types.' + type)}}
                    </div>
                    <div v-if="Object.keys(items).length != 0" class="col-sm-12 col-md-4 fs-xs fw-300 text-right">
                        <div class="row">
                            <div class="col-7 pr-0">
                                <b-form-select
                                    v-model="selectedSort"
                                    :options="sortOptions"
                                    value-field="id"
                                    text-field="text"
                                    size="sm" 
                                    @change="sortItems">
                                </b-form-select>
                            </div>
                            <div class="pl-0 col-5 d-flex align-self-center justify-content-end">
                                <a class="btn btn-xs btn-outline-primary text-primary itemExpand" @click="showAllDetails(type, null)">{{isExpand == 'Expand' ? $t('button_link.expand_details') : $t('button_link.collapse_details')}}</a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </td>
        </tr>
        <tr v-if="Object.keys(items).length == 0"><td class="text-secondary" colspan="10"><small>{{$t('label.no', {'item': $t('salon_report.item_types.' + type)})}}</small></td></tr>
        <tr v-for="(item, i) in items" :key="item.completedID" class="itemRow">
            <td class="align-middle">{{i+1}}</td>
            <td class="align-middle">
                <a class="fw-500 text-primary link" :id="'items_' + item.completedID" @click="showDetails($event, type)">{{item.item.title}}</a>
                <div class="mt-1 detailTable" style="display: none;">
                     <table class="table table-sm table-hover table-bordered table-striped">
                        <tr>
                            <th>{{$t('table.header.date')}}</th>
                            <td>{{convertTimestampToDateTime(item.createDate)}}</td>    
                        </tr>
                        <tr>
                            <th>{{$t('label.order_number')}}</th>
                            <td>{{insertLeadingZero(item.orderID)}}</td>    
                        </tr>
                        <tr>
                            <th>{{$t('label.receipt_number')}}</th>
                            <td>{{insertLeadingZero(item.receiptID)}}</td>    
                        </tr>
                        <tr>
                            <th>{{$t('table.header.outlet')}}</th>
                            <td>{{getOutletName(item.outletID)}}</td>    
                        </tr>
                        <tr>
                            <th>{{$t('subMenu.my_salon_member') + $t('table.header.name')}}</th>
                            <td>{{item.member.displayName}}</td>    
                        </tr>
                        <tr>
                            <th>{{$t('table.header.contact')}}</th>
                            <td>{{item.member.mobile}}</td>    
                        </tr>
                        <tr>
                            <th>{{$t('subMenu.salon_report_payment')}}</th>
                            <td>{{$t('salon_report.redeem.' + (item.redeem == "" ? 'sales' : item.redeem))}}</td>    
                        </tr>
                    </table>    
                </div>
            </td>
            <!-- <td class="align-middle" title="Outlet">{{getOutletName(item.outletID)}}</td> -->
            <td class="h-100" title="Position">
                <div class="row h-100 pl-3 pr-3" v-if="item.staffs.length != 0">
                    <div class="col-sm-12 d-flex align-items-center" :class="{'border-bottom': i+1 != item.staffs.length}" v-for="(staff, i) in item.staffs" :key="i">{{i+1}}</div>
                </div>
                <div v-else class="pl-3 d-flex align-items-center h-100">-</div>
            </td>
            <td class="h-100" title="Staff">
                <div class="row h-100 pl-3 pr-3" v-if="item.staffs.length != 0">
                    <div class="col-sm-12 d-flex align-items-center" :class="{'border-bottom': i+1 != item.staffs.length}" v-for="(staff, i) in item.staffs" :key="i">{{staff.name}}</div>
                </div>
                <div v-else class="pl-3 d-flex align-items-center h-100">-</div>
            </td>
            <td class="align-middle" title="Amount">{{getSubTotal(item.price, item.discount, item.outstandings)}}</td>
            <td class="h-100" title="Effort">
                <div class="row h-100 pl-3 pr-3" v-if="item.staffs.length != 0">
                    <div class="col-sm-12 d-flex align-items-center" :class="{'border-bottom': i+1 != item.staffs.length}" v-for="(staff, i) in item.staffs" :key="i">{{formatPrice(staff.effort)}}</div>
                </div>
                <div v-else class="pl-3 d-flex align-items-center h-100">-</div>
            </td>
            <td class="h-100" title="Effort %">
                <div class="row h-100 pl-3 pr-3" v-if="item.staffs.length != 0">
                    <div class="col-sm-12 d-flex align-items-center" :class="{'border-bottom': i+1 != item.staffs.length}" v-for="(staff, i) in item.staffs" :key="i">
                        {{calculateEffortPercentage(
                            getSubTotal(item.price, item.discount, item.outstandings),
                            staff.effort
                        )}}
                    </div>
                </div>
                <div v-else class="pl-3 d-flex align-items-center h-100">-</div>
            </td>
            <td class="h-100" title="Fee">
                <div class="row h-100 pl-3 pr-3" v-if="item.staffs.length != 0">
                    <div class="col-sm-12 d-flex align-items-center" :class="{'border-bottom': i+1 != item.staffs.length}" v-for="(staff, i) in item.staffs" :key="i">{{formatPrice(staff.fee)}}</div>
                </div>
                <div v-else class="pl-3 d-flex align-items-center h-100">-</div>
            </td>
            <td class="align-middle text-center">
                <a class="link d-block text-primary" title="Edit Staff Commission" @click="showEditCommission(
                    type, item.completedID, item.item.title, item.orderID, item.receiptID, item.outletID, getSubTotal(item.price, item.discount, item.outstandings), item.staffs
                )">
                    <i class="fal fa-pen"></i>
                </a>
            </td>
        </tr>
        <!-- <tr>
            <td colspan="4" class="border-top-bottom-2 text-right fw-500">SUBTOTAL</td>
            <td class="border-top-bottom-2 fw-500">{{parseFloat(objSubTotal.subTotal).toFixed(2)}}</td>
            <td class="border-top-bottom-2 fw-500 pl-3">{{parseFloat(objSubTotal.effort).toFixed(2)}}</td>
            <td class="border-top-bottom-2 fw-500 pl-3">-</td>
            <td class="border-top-bottom-2 fw-500 pl-3">{{parseFloat(objSubTotal.fee).toFixed(2)}}</td>
            <td class="border-top-bottom-2 fw-500"></td>
        </tr> -->
    </tbody>
</template>
<script>
import _ from 'lodash'
import {getSubTotal, calculateEffortPercentage, calculateTotalStaffEffortFee} from './../../../../assets/js/dashboard/salonReport/salonReport'
import {getIcon, getOutletName} from './../../../../assets/js/dashboard/dashboard'
import {convertTimestampToDateTime, formatPrice, insertLeadingZero} from './../../../../assets/js/dashboard/utilities'
export default {
    name:'commissionItemsTable',
    props:{ 
        items: { type: Array },
        type: { type: String },
    },
    data(){
        return{
            isExpand: "Expand",
            selectedSort: 'date_desc'
        }
    },
    computed:{
        sortOptions(){
            let options = this.$i18n.messages[this.$i18n.locale].salon_report.commission.item_sort_options
            var arr = []
            for(var i in options){
                arr.push({
                    id: i,
                    text: options[i]
                })
            }
            return arr
        },
        objSubTotal(){
            var subTotal = 0
            var effort = 0
            var fee = 0
            for(var i=0; i<this.items.length; i++){
                subTotal += getSubTotal(this.items[i].price, this.items[i].discount, this.items[i].outstandings)
                var staff = calculateTotalStaffEffortFee(this.items[i].staffs)
                effort += staff.effort
                fee += staff.fee
            }
            var obj = {
                subTotal: subTotal,
                effort: effort,
                fee: fee
            }
            return obj
        }
    },
    watch:{
        items(value){
            this.setTotalEntries(value.length)
        }
    },
    methods:{
        getIcon(type){
            return getIcon(type)
        },
        getOutletName(id){
            return getOutletName(id, JSON.parse(this.$store.state.outlets));
        },
        insertLeadingZero(number){
            return insertLeadingZero(number);
        },
        convertTimestampToDateTime(ts){
            return convertTimestampToDateTime(ts);
        },
        formatPrice(p){
            return formatPrice(p);
        },
        calculateEffortPercentage(amount, effort){
            var percentage = amount == 0 ? "-" : formatPrice(calculateEffortPercentage(amount, effort)) + "%"
            return percentage;
        },
        getSubTotal(price, discount, outstandings){
            return formatPrice(getSubTotal(price, discount, outstandings))
        },
        sortItems(){
            this.$emit('sortItems', this.selectedSort, this.type) 
        },
        showDetails(e, type){
            var link = e.target.id;
            var detailsDiv = document.getElementById(link).nextSibling;
            detailsDiv.style.display = detailsDiv.style.display == 'none' ? 'block' : 'none';

            var hideCount = 0;
            var allRow = document.getElementById("tbody_item_" + type).querySelectorAll(".detailTable")

            for(var i=0; i<allRow.length; i++){
                if(allRow[i].style.display == 'none'){
                    hideCount++
                }
            }

            this.isExpand = hideCount == this.items.length ? "Expand" : "Collapse"
            this.$emit('setExpandAll', this.isExpand)
        },
        showAllDetails(type, isExpandAll){
            var isExpand = false;
            if(this.isExpand == "Expand"){
                isExpand = true;
                this.isExpand = "Collapse"
            }else{
                isExpand = false;
                this.isExpand = "Expand"
            }
            var detailsContainer = document.getElementById("tbody_item_" + type).querySelectorAll(".detailTable");
            for(var i=0; i<detailsContainer.length; i++){
                if(isExpandAll != null){
                    if(isExpandAll){
                        if(detailsContainer[i].style.display == 'none'){
                            detailsContainer[i].style.display = 'block'
                        }
                        this.isExpand = "Collapse";
                    }else{
                        if(detailsContainer[i].style.display == 'block'){
                            detailsContainer[i].style.display = 'none'
                        }
                        this.isExpand = "Expand";
                    }
                }else{
                    if(isExpand){
                        if(detailsContainer[i].style.display == 'none'){
                            detailsContainer[i].style.display = 'block'
                        }
                    }else{
                        if(detailsContainer[i].style.display == 'block'){
                            detailsContainer[i].style.display = 'none'
                        }
                    }
                }
            }
            this.$emit('setExpandAll', this.isExpand)
        },
        showEditCommission(type, completedID, title, orderID, receiptID, outletID, price, staffs){
            price = typeof price == 'string' ?  parseFloat(price.replace(",", "")) : price
            var staffList = [];
            for(var i=0; i<4; i++){
                if(i<staffs.length){
                    staffList.push(staffs[i])
                }else{
                    staffList.push({
                        staffID: 'no',
                        name: 'No Staff',
                        effort: 0,
                        pctg: 0,
                        pctg2: 0,
                        fee: 0
                    })      
                }
            }
            var data = {
                type: type,
                completedID: completedID,
                title: title,
                orderID: this.insertLeadingZero(orderID),
                receiptID: this.insertLeadingZero(receiptID),
                outletID: outletID,
                outlet: this.getOutletName(outletID),
                price: price,
                staffs: staffList
            }
            this.$emit('showEditCommission', data)
        },
        setTotalEntries(len){
            this.$emit('setTotalEntries', len)
        },
        
    },
}
</script>
<style scoped>
.link{
    cursor: pointer;
}
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>